import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.27323 5.89823C4.48477 5.6867 4.82773 5.6867 5.03927 5.89823L7.5 8.35897L9.96073 5.89823C10.1723 5.6867 10.5152 5.6867 10.7268 5.89823C10.9383 6.10977 10.9383 6.45273 10.7268 6.66427L7.88302 9.50802C7.67148 9.71955 7.32852 9.71955 7.11698 9.50802L4.27323 6.66427C4.0617 6.45273 4.0617 6.10977 4.27323 5.89823Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 1C7.79915 1 8.04167 1.24251 8.04167 1.54167V9.125C8.04167 9.42416 7.79915 9.66667 7.5 9.66667C7.20085 9.66667 6.95833 9.42416 6.95833 9.125V1.54167C6.95833 1.24251 7.20085 1 7.5 1Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.54167 8.58333C1.84082 8.58333 2.08333 8.82585 2.08333 9.125V12.9167H12.9167V9.125C12.9167 8.82585 13.1592 8.58333 13.4583 8.58333C13.7575 8.58333 14 8.82585 14 9.125V12.9167C14 13.204 13.8859 13.4795 13.6827 13.6827C13.4795 13.8859 13.204 14 12.9167 14H2.08333C1.79602 14 1.52047 13.8859 1.3173 13.6827C1.11414 13.4795 1 13.204 1 12.9167V9.125C1 8.82585 1.24251 8.58333 1.54167 8.58333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.27323 5.89823C4.48477 5.6867 4.82773 5.6867 5.03927 5.89823L7.5 8.35897L9.96073 5.89823C10.1723 5.6867 10.5152 5.6867 10.7268 5.89823C10.9383 6.10977 10.9383 6.45273 10.7268 6.66427L7.88302 9.50802C7.67148 9.71955 7.32852 9.71955 7.11698 9.50802L4.27323 6.66427C4.0617 6.45273 4.0617 6.10977 4.27323 5.89823Z",
			stroke: "currentColor",
			strokeWidth: .3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 1C7.79915 1 8.04167 1.24251 8.04167 1.54167V9.125C8.04167 9.42416 7.79915 9.66667 7.5 9.66667C7.20085 9.66667 6.95833 9.42416 6.95833 9.125V1.54167C6.95833 1.24251 7.20085 1 7.5 1Z",
			stroke: "currentColor",
			strokeWidth: .3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.54167 8.58333C1.84082 8.58333 2.08333 8.82585 2.08333 9.125V12.9167H12.9167V9.125C12.9167 8.82585 13.1592 8.58333 13.4583 8.58333C13.7575 8.58333 14 8.82585 14 9.125V12.9167C14 13.204 13.8859 13.4795 13.6827 13.6827C13.4795 13.8859 13.204 14 12.9167 14H2.08333C1.79602 14 1.52047 13.8859 1.3173 13.6827C1.11414 13.4795 1 13.204 1 12.9167V9.125C1 8.82585 1.24251 8.58333 1.54167 8.58333Z",
			stroke: "currentColor",
			strokeWidth: .3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDownload;
